import { back as backApi, init as initApi, selected as selectedApi } from "../../service/WebEvaluation1Service";

export const INIT_SUCCESS = "WEB_EVALUATION1_INIT_SUCCESS";
export const INIT_FAIL = "WEB_EVALUATION1_INIT_FAIL";
export const EVALUATION_SELECT_SUCCESS = "WEB_EVALUATION1_EVALUATION_SELECT_SUCCESS";
export const EVALUATION_SELECT_FAIL = "WEB_EVALUATION1_EVALUATION_SELECT_FAIL";
export const EVALUATION_BACK_SUCCESS = "WEB_EVALUATION1_EVALUATION_BACK_SUCCESS";
export const EVALUATION_BACK_FAIL = "WEB_EVALUATION1_EVALUATION_BACK_FAIL";

export const init = request => dispatch => {
  const grade = request.grade;
  const classNumber = request.classNumber;
  const number = request.number;
  const name = request.name;
  initApi(request)
    .then(response => {
      const itemName = response.stickerList.itemName;
      const categoryName = response.stickerList.categoryName;
      const title = response.title;
      const itemId = response.stickerList.itemId;
      const imageE = response.stickerList.stickerData[0].filePath1;
      const imageD = response.stickerList.stickerData[0].filePath2;
      const imageC = response.stickerList.stickerData[0].filePath3;
      const imageB = response.stickerList.stickerData[0].filePath4;
      const imageA = response.stickerList.stickerData[0].filePath5;
      const imageS = response.stickerList.stickerData[0].filePath6;
      const gradeRange = response.gradeRange;

      dispatch({
        type: INIT_SUCCESS,
        payload: {
          itemName: itemName,
          categoryName: categoryName,
          grade: grade,
          classNumber: classNumber,
          number: number,
          name: name,
          title: title,
          imageE: imageE,
          imageD: imageD,
          imageC: imageC,
          imageB: imageB,
          imageA: imageA,
          imageS: imageS,
          itemId: itemId,
          gradeRange: gradeRange
        }
      });
    })
    .catch(error => {
      dispatch({ type: INIT_FAIL, payload: { error: error } });
    });
};
export const selected = request => dispatch => {
  selectedApi(request)
    .then(response => {
      if (response.redirectPage) {
        dispatch({
          type: EVALUATION_SELECT_SUCCESS,
          payload: {}
        });
        alert("評価の実施が完了しました。前の画面に戻ります。");
        window.location.href = response.redirectPage;
        return;
      }
      const itemName = response.stickerList.itemName;
      const categoryName = response.stickerList.categoryName;
      const title = response.title;
      const imageE = response.stickerList.stickerData[0].filePath1;
      const imageD = response.stickerList.stickerData[0].filePath2;
      const imageC = response.stickerList.stickerData[0].filePath3;
      const imageB = response.stickerList.stickerData[0].filePath4;
      const imageA = response.stickerList.stickerData[0].filePath5;
      const imageS = response.stickerList.stickerData[0].filePath6;
      const itemId = response.stickerList.itemId;

      dispatch({
        type: EVALUATION_SELECT_SUCCESS,
        payload: {
          itemName: itemName,
          categoryName: categoryName,
          title: title,
          imageE: imageE,
          imageD: imageD,
          imageC: imageC,
          imageB: imageB,
          imageA: imageA,
          imageS: imageS,
          itemId: itemId
        }
      });
    })
    .catch(error => {
      dispatch({ type: EVALUATION_SELECT_FAIL, payload: { error: error } });
    });
};
export const back = request => dispatch => {
  backApi(request)
    .then(response => {
      if (response.message !== null) {
        alert(`エラーコード: ${response.messageCode}\r\n メッセージ：${response.message}`);
        dispatch({ type: EVALUATION_BACK_FAIL, payload: { error: response.message } });
        return;
      }
      const itemName = response.stickerList.itemName;
      const categoryName = response.stickerList.categoryName;
      const title = response.title;
      const imageE = response.stickerList.stickerData[0].filePath1;
      const imageD = response.stickerList.stickerData[0].filePath2;
      const imageC = response.stickerList.stickerData[0].filePath3;
      const imageB = response.stickerList.stickerData[0].filePath4;
      const imageA = response.stickerList.stickerData[0].filePath5;
      const imageS = response.stickerList.stickerData[0].filePath6;
      const itemId = response.stickerList.itemId;

      dispatch({
        type: EVALUATION_BACK_SUCCESS,
        payload: {
          itemName: itemName,
          categoryName: categoryName,
          title: title,
          imageE: imageE,
          imageD: imageD,
          imageC: imageC,
          imageB: imageB,
          imageA: imageA,
          imageS: imageS,
          itemId: itemId
        }
      });
    })
    .catch(error => {
      dispatch({ type: EVALUATION_BACK_FAIL, payload: { error: error } });
    });
};
